var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMoveLeft(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.5 31.0175H12.5C5.25996 31.0175 2.16663 27.9242 2.16663 20.6842V12.6842C2.16663 5.44416 5.25996 2.35083 12.5 2.35083H20.5C27.74 2.35083 30.8333 5.44416 30.8333 12.6842V20.6842C30.8333 27.9242 27.74 31.0175 20.5 31.0175ZM12.5 4.35083C6.35329 4.35083 4.16663 6.5375 4.16663 12.6842V20.6842C4.16663 26.8308 6.35329 29.0175 12.5 29.0175H20.5C26.6466 29.0175 28.8333 26.8308 28.8333 20.6842V12.6842C28.8333 6.5375 26.6466 4.35083 20.5 4.35083H12.5Z",
    fill: "#0033CC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.18 22.3907C17.9267 22.3907 17.6734 22.2974 17.4734 22.0974L12.7667 17.3907C12.38 17.004 12.38 16.364 12.7667 15.9774L17.4734 11.2707C17.86 10.884 18.5 10.884 18.8867 11.2707C19.2734 11.6574 19.2734 12.2974 18.8867 12.684L14.8867 16.684L18.8867 20.684C19.2734 21.0707 19.2734 21.7107 18.8867 22.0974C18.7 22.2974 18.4467 22.3907 18.18 22.3907Z",
    fill: "#0033CC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoveLeft);
export default __webpack_public_path__ + "static/media/move-left.7aebf40ae38c2348fdc0ab8694bbf39f.svg";
export { ForwardRef as ReactComponent };